import { Outlet } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { EnrollmentUpperNavBar } from 'components/molecules/EnrollmentUpperNavBar/EnrollmentUpperNavBar';

const OutletContainer = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex: 1;
        padding-top: ${theme.sizes.auth.authUpperNavBarHeightMobile}px;

        @media (${theme.sizes.mediaQueries.desktopMin}) {
            padding-top: ${theme.sizes.auth.authUpperNavBarHeight}px;
        }
    `}
`;
export const EnrollmentLayout = () => (
    <>
        <EnrollmentUpperNavBar />
        <OutletContainer>
            <Outlet />
        </OutletContainer>
    </>
);
